/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Checkout_Terms_Note1Inputs */

const vi_sitesettings_checkout_terms_note1 = /** @type {(inputs: Sitesettings_Checkout_Terms_Note1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú đơn chờ xác nhận`)
};

/**

* @param {Sitesettings_Checkout_Terms_Note1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_checkout_terms_note1 = /** @type {((inputs?: Sitesettings_Checkout_Terms_Note1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Checkout_Terms_Note1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_checkout_terms_note1(inputs)
});
export { sitesettings_checkout_terms_note1 as "siteSettings_checkout_terms_note" }